import { Injectable } from '@angular/core'
import { createEffect, Actions, ofType } from '@ngrx/effects'
import * as LoaderActions from './loader.actions'
import { tap } from 'rxjs/operators'
import { GbLoadingSpinnerDialogService } from 'libs/shared/ui/src/lib/gb-loading-spinner/gb-loading-spinner-dialog.service'

@Injectable()
export class LoaderEffects {
  constructor(private actions$: Actions, private loadingSpinnerDialogService: GbLoadingSpinnerDialogService) {}

  showLoaderDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoaderActions.showLoaderDialog),
        tap((action) => {
          this.loadingSpinnerDialogService.showLoadingSpinnerDialog(action.id, action.label)
        }),
      ),
    { dispatch: false },
  )

  hideLoaderDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoaderActions.hideLoaderDialog),
        tap((action) => this.loadingSpinnerDialogService.hideLoadingSpinnerDialog(action.id)),
      ),
    { dispatch: false },
  )
}
